﻿import {translation} from "@2d-front-monorepo/core";
import {Message} from "@2d-front-monorepo/design-library";
import {Residencies, ResidencyComponent, ResidencyId} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";

import {JSX} from "react";
import {useParams} from "react-router";
import {API_ENDPOINT} from "../../api-endpoint";
import {PermitsBackButtonFrame} from "../../components/PermitsBackButton";
import {usePermits} from "../../hooks/usePermits";

const filesPrefix = API_ENDPOINT.fileDownload;

export default function ViewResidency(): JSX.Element {
	const {residencyId} = useParams<{ residencyId: string }>() as { residencyId: ResidencyId };
	const {permits, holderData} = usePermits();
	const residency = Residencies.get(permits, residencyId);

	if (residencyId == null || residency?.id == null) {
		return (<Message title={{text: `Invalid residency id: [${residencyId}]`}} type="error"/>);
	}

	return (
		<>
			<div className="layout horizontal aligned middle">
				<h2 className="flex">{translation(PermitTranslations.residency)}</h2>
				{/*<EntityStatusComponent entity={residency}/>*/}
			</div>
			<hr className="no-margin-start"/>
			<ResidencyComponent residency={residency} holder={holderData} filesPrefix={filesPrefix}/>
			<PermitsBackButtonFrame/>
		</>
	)
}
